/*
 * The texts of the announcements extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		announcement: {
			create: 'Create announcement',
			edit: 'Edit announcement',
			delete: 'Delete announcement',
		},
	},
	modals: {
		edit_announcement: {
			create: 'Create new announcement',
			edit: 'Edit announcement',
		},
	},
	confirms: {
		remove_announcement: 'Remove announcement',
		remove_announcement_title: `Remove the announcement "{title}"?`,
	},
	data: {
		announcement: {
			id: 'Id',
			title: 'Title',
			type: 'Type',
			description: 'Description',
			url: 'URL',
			start_at: 'Start date',
			end_at: 'End date',
		},
	},
	pages: {
		settings: {
			announcements: {
				title: 'Announcements',
			},
		},
	},
	tabs: {
		admin_settings: {
			announcements: 'Announcements',
		},
	},
	widgets: {
		announcements: {
			title: 'Announcements',
		},
	},
};
